import { observer } from 'mobx-react-lite';
import { ControlIcons } from 'owa-control-icons';
import { getIconForFileProvider as getAddProviderIconCSS } from 'owa-fileprovider-icon';
import { getAddableFileProviders } from 'owa-fileprovider-store/lib/selectors/getAddableFileProviders';
import loc from 'owa-localize';
import * as React from 'react';
import { showFileProviderInlineView } from '../actions/internalActions';
import { getFilePickerStore } from '../store/filePickerStore';
import { AddAFileProvider } from './AddFileProviderView.locstring.json';
import FileProviderView from './FileProviderView';
import { isFeatureEnabled } from 'owa-feature-flags';

const styles = require('./AddFileProviderView.scss');

export default observer(function AddFileProviderView() {
    return (
        <div>
            {shouldShowAddAProviderView() && (
                <FileProviderView
                    name={loc(AddAFileProvider)}
                    icon={getAddProviderIconCSS(
                        ControlIcons.Add,
                        isFeatureEnabled('doc-filePicker-newNavigationHierarchy')
                            ? styles.iconSmall
                            : styles.icon
                    )}
                    onClick={onAddProviderClicked}
                    ariaLabel={loc(AddAFileProvider)}
                    isSelected={getFilePickerStore().viewState.showFileProviderInlineView}
                />
            )}
        </div>
    );
});

// We only show the "Add a Provider" button when there is some provider that is addable that the user does not yet have.
// Otherwise it would clutter the left nav, and clicking it would open an empty panel.
function shouldShowAddAProviderView(): boolean {
    return getAddableFileProviders().length > 0;
}

function onAddProviderClicked() {
    showFileProviderInlineView(true);
}
